import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DelegatedLabeledComponent } from '../delegated-labeled.component';

export interface MultiSelectOption {
  value: string;
  label: string;
}

@Component({
  selector: 'subs-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class MultiSelectComponent
  extends DelegatedLabeledComponent
  implements OnChanges
{
  constructor(
    sanitizer: DomSanitizer,
    private formGroupDirective: FormGroupDirective,
  ) {
    super(sanitizer);
  }

  @Input()
  options: MultiSelectOption[] = [];

  @Input()
  errorMessage?: string;

  @Input()
  disabled?: boolean;

  @Input()
  horizontal: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      this.removeInvalidSelections();
    }
  }

  getOptionLabel(value: string): string {
    return (
      this.options.find((option) => option.value === value)?.label ?? value
    );
  }

  private removeInvalidSelections(): void {
    if (!this.controlName) {
      return;
    }

    const control = this.formGroupDirective.form?.get(this.controlName);

    if (!control || !Array.isArray(control.value)) {
      return;
    }

    const validValues = new Set(this.options.map((option) => option.value));

    const selectedValues: string[] = control.value;

    const validSelectedValues = selectedValues.filter((value) =>
      validValues.has(value),
    );

    if (validSelectedValues.length !== selectedValues.length) {
      control.setValue(validSelectedValues);
    }
  }
}
